import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface NicheData {
  interest: string;
  headlines: {
    headline: string;
    subheadlines: string[];
    products: string[];
    services: string[];
    searchPotential: number;
    monetizationPotential: number;
    audiencePassion: number;
  }[];
}
interface KeywordData {
  interest: string;
  headlines: Array<String>;
}

interface HeadlineData {
  niche: string;
  headlines: Array<String>;
}

interface NicheJobData {
  _id?: string;
  createdAt: Date;
  finishedAt: Date;
  userId: string;
  type: "NICHE";
  data: NicheData;
}

interface KeywordJobData {
  _id?: string;
  createdAt: Date;
  finishedAt: Date;
  userId: string;
  type: "KEYWORD";
  data: KeywordData;
}

interface HeadlineJobData {
  _id?: string;
  createdAt: Date;
  finishedAt: Date;
  userId: string;
  type: "HEADLINE";
  data: HeadlineData;
}

type ToolJobType = "NICHE" | "HEADLINE" | "KEYWORD";

type ToolJobData = NicheJobData | KeywordJobData | HeadlineJobData;

interface ToolsState {
  tool: {
    type: ToolJobType;
    createDialogOpened: boolean;
    unlimitedDialogOpened: boolean;
    status: "loading" | "initialized" | "unauthorized" | "creating" | "created";
    data: ToolJobData | null;
    defaultSearch?: string;
  };
}

const initialState: ToolsState = {
  tool: {
    type: "HEADLINE",
    createDialogOpened: false,
    unlimitedDialogOpened: false,
    status: "loading",
    data: null,
  },
};

const toolsSlice = createSlice({
  name: "tools",
  initialState,
  reducers: {
    setCreateDialogOpened: (state, action: PayloadAction<boolean>) => {
      state.tool.createDialogOpened = action.payload;
    },
    setDefaultSearch: (state, action: PayloadAction<string>) => {
      state.tool.defaultSearch = action.payload;
    },
    setUnlimitedDialogOpened: (state, action: PayloadAction<boolean>) => {
      state.tool.unlimitedDialogOpened = action.payload;
    },
    setData: (state, action: PayloadAction<ToolJobData | null>) => {
      state.tool.data = action.payload;
    },
    setStatus: (
      state,
      action: PayloadAction<
        "loading" | "initialized" | "unauthorized" | "creating" | "created"
      >
    ) => {
      state.tool.status = action.payload;
    },
    setType: (state, action: PayloadAction<ToolJobType>) => {
      state.tool.type = action.payload;
    },
  },
});

export type {
  HeadlineData, HeadlineJobData, KeywordJobData, NicheJobData, ToolJobData,
  ToolJobType, ToolsState
};
export const { } = toolsSlice.actions;
export default toolsSlice;
